export default "__VITE_ASSET__BZiAru3z__"